const useRunEnv = () => {
    let runEnv: string; // prod | staging | dev
    if (typeof process !== 'undefined' && process?.server) {
        runEnv = process.env.NUXT_PUBLIC_RUN_ENV ?? 'staging';
    } else {
        ({ runEnv } = useRuntimeConfig().public);
    }
    return runEnv as 'prod' | 'staging' | 'dev';
};

export default useRunEnv;
